// extracted by mini-css-extract-plugin
export default {"guardianAlert":"GuardianAlert_guardianAlert__PmIVa","backToDashboard":"GuardianAlert_backToDashboard__6p+3H"};